import { render, staticRenderFns } from "./StatisticsUsersData.vue?vue&type=template&id=1cec967f&"
import script from "./StatisticsUsersData.vue?vue&type=script&lang=js&"
export * from "./StatisticsUsersData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports